/**
 * A user's role on one site, ranked everyone < bookie < admin < owner < system.
 *
 * What each role may do is not described here but in the capability table
 * (`capabilities.ts`, ADR 0015) — ask `can(role, capability)` rather than
 * comparing roles at a call site.
 */
var Role;
(function (Role) {
    Role["everyone"] = "everyone";
    Role["bookie"] = "bookie";
    Role["admin"] = "admin";
    Role["owner"] = "owner";
    Role["system"] = "system"; // Root: the highest role on every site (see resolveSiteRole)
})(Role || (Role = {}));
/**
 * @deprecated bookie-or-higher. Use `can(role, capability)` from
 * `capabilities.ts`: this name hid that the app's context had a second
 * `hasEditPermission` meaning admin-or-higher (D120).
 */
const hasEditPermission = (role) => {
    return (role === Role.bookie ||
        role === Role.admin ||
        role === Role.owner ||
        role === Role.system);
};
const hasAtLeastRole = (role, requiredRole) => {
    if (requiredRole === Role.everyone) {
        return true;
    }
    if (requiredRole === Role.system) {
        return role === Role.system;
    }
    if (requiredRole === Role.owner) {
        return role === Role.owner || role === Role.system;
    }
    if (requiredRole === Role.admin) {
        return role === Role.owner || role === Role.system || role === Role.admin;
    }
    if (requiredRole === Role.bookie) {
        return (role === Role.owner ||
            role === Role.system ||
            role === Role.admin ||
            role === Role.bookie);
    }
    return false;
};
const toRole = (role) => {
    switch (role) {
        case 'admin':
            return Role.admin;
        case 'bookie':
            return Role.bookie;
        case 'owner':
            return Role.owner;
        case 'system':
            return Role.system;
        case 'support':
            return Role.bookie;
        default:
            return Role.everyone;
    }
};
export { Role, toRole, hasEditPermission, hasAtLeastRole };
//# sourceMappingURL=role.js.map